//Library Imports
import React, { useState, useEffect } from "react";
import styled from "styled-components";

//Local Imports
import ListIcon from "../../../assets/img/ContentViewFilter/list.svg";
import CardIcon from "../../../assets/img/ContentViewFilter/card.svg";
import ListIconActive from "../../../assets/img/ContentViewFilter/list-active-transparent.svg";
import CardIconActive from "../../../assets/img/ContentViewFilter/card-active-transparent.svg";

interface IToggleView {
  isListView?: boolean;
  onlyCard?: boolean;
  onlyList?: boolean;
  onToggle?: (value: boolean) => void;
  setIsListView?: (value: boolean) => void;
}

const ToggleView: React.FC<IToggleView> = (props) => {
  const { setIsListView, onToggle, onlyCard, onlyList, isListView } = props;
  const [activeTab, setActiveTab] = useState(isListView ? "list" : "card");

  useEffect(() => {
    const viewType = props.isListView ? "list" : "card";
    if (viewType !== activeTab) {
      setActiveTab(viewType);
    }
  }, [props.isListView]);

  const switchLayout = (cardType: string) => {
    if (onlyCard || onlyList) return;
    setActiveTab(cardType);
    if (cardType === "card") {
      if (setIsListView) setIsListView(false);
      localStorage.setItem("isListView", "false");
    } else {
      if (setIsListView) setIsListView(true);
      localStorage.setItem("isListView", "true");
    }
    if (onToggle) onToggle(cardType === "list");
  };

  return (
    <StyleWrapper onlyCard={onlyCard} onlyList={onlyList}>
      {onlyCard === true && onlyList === undefined ? null : (
        <div
          onClick={() => switchLayout("list")}
          data-id="qa-icon"
          className={`list-view ${activeTab === "list" ? "active" : ""}`}
        >
          {activeTab === "list" ? (
            <img src={ListIconActive} alt="card icon" />
          ) : (
            <img src={ListIcon} alt="card icon" />
          )}
        </div>
      )}
      {onlyList === true && onlyCard === undefined ? null : (
        <div
          onClick={() => switchLayout("card")}
          data-id="qa-icon-one"
          className={`card-view ${activeTab === "card" ? "active" : ""}`}
        >
          {activeTab === "card" ? (
            <img src={CardIconActive} alt="card icon" />
          ) : (
            <img src={CardIcon} alt="card icon" />
          )}
        </div>
      )}
    </StyleWrapper>
  );
};
export default ToggleView;

const StyleWrapper = styled.div<{ onlyCard?: boolean; onlyList?: boolean }>`
  cursor: pointer;
  display: inline-block;
  display: flex;
  .card-view {
    display: inline-block;
    width: 52px;
    border: solid 1px #dadada;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    ${(props) =>
      props.onlyCard
        ? "border-radius: 8px;"
        : `border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;`}
  }
  .list-view {
    display: inline-block;
    border: solid 1px #dadada;
    width: 52px;
    height: 41px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    ${(props) =>
      props.onlyList
        ? "border-radius: 8px;"
        : `
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;`}
  }
  .active {
    background-color: #def6e6;
  }
`;
